// @flow strict

import * as React from 'react'

import styles from './PaidButton.module.scss'
import Button, { type Props as ButtonProps } from './'

const PaidButton = (props: ButtonProps) => (
  <Button {...props} className={styles.paidButtonStyles}>
    {props.children}
  </Button>
)

export default PaidButton
